
<v-app>
    <v-main>
        <transition name="page" mode="out-in">
            <component :is="layout"></component>
        </transition>
    </v-main>
</v-app>
